export default {
  namespaced: true,
  companies: {
    title: 'Companies | Company',
    name: 'name',
    description: 'description',
    tenant: 'Tenant',
    companies: 'Companies',
    select: 'Select'
  }
}
